import colors from '../globals/colors';
/**
 * Form colors
 */
const formSecondary = `#FFFFFF`;
const form = {
    size: {
        small: {
            fontSize: '14px',
            height: '34px',
            lineHeight: '18px',
            padding: '12px',
        },
        medium: {
            fontSize: '16px',
            height: '46px',
            lineHeight: '20px',
            padding: '16px',
        },
    },
    variant: {
        lighten: {
            idle: {
                color: colors.grey84,
                placeHolderColor: colors.grey36,
                backgroundColor: formSecondary,
                borderColor: colors.grey24,
                iconColor: colors.secondary.lighten,
            },
            disabled: {
                color: colors.grey36,
                placeHolderColor: colors.grey36,
                backgroundColor: formSecondary,
                borderColor: colors.grey24,
                iconColor: colors.grey36,
            },
            active: {
                color: colors.secondary.normal,
                placeHolderColor: colors.secondary.normal,
                backgroundColor: formSecondary,
                borderColor: colors.secondary.lighten,
                iconColor: colors.secondary.lighten,
            },
            hover: {
                color: colors.grey84,
                placeHolderColor: colors.grey60,
                backgroundColor: formSecondary,
                borderColor: colors.secondary.lighten,
                iconColor: colors.secondary.lighten,
            },
            focus: {
                color: colors.secondary.normal,
                placeHolderColor: colors.secondary.normal,
                backgroundColor: formSecondary,
                borderColor: colors.secondary.lighten,
                iconColor: colors.secondary.lighten,
            },
            error: {
                color: colors.alternativeError,
                placeHolderColor: colors.alternativeError,
                backgroundColor: formSecondary,
                borderColor: colors.alternativeError,
                iconColor: colors.alternativeError,
            },
        },
        darken: {
            idle: {
                color: colors.grey84,
                placeHolderColor: colors.grey60,
                backgroundColor: colors.grey4,
                borderColor: colors.grey24,
                iconColor: colors.secondary.lighten,
            },
            disabled: {
                color: colors.grey36,
                placeHolderColor: colors.grey36,
                backgroundColor: colors.grey4,
                borderColor: colors.grey24,
                iconColor: colors.grey36,
            },
            active: {
                color: colors.secondary.normal,
                placeHolderColor: colors.secondary.normal,
                backgroundColor: colors.grey4,
                borderColor: colors.secondary.lighten,
                iconColor: colors.secondary.lighten,
            },
            hover: {
                color: colors.grey84,
                placeHolderColor: colors.grey60,
                backgroundColor: colors.grey4,
                borderColor: colors.secondary.lighten,
                iconColor: colors.secondary.lighten,
            },
            focus: {
                color: colors.secondary.normal,
                placeHolderColor: colors.secondary.normal,
                backgroundColor: colors.grey4,
                borderColor: colors.secondary.lighten,
                iconColor: colors.secondary.lighten,
            },
            error: {
                color: colors.alternativeError,
                placeHolderColor: colors.alternativeError,
                backgroundColor: colors.grey4,
                borderColor: colors.alternativeError,
                iconColor: colors.alternativeError,
            },
        },
    },
};
export default form;
